import './Ranking.css';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { redirect } from 'redux-first-router';
import isEmpty from 'lodash/isEmpty';
import { eventHandler, GAAction } from '@analytics';
import { actions as Pages } from '@pages/names';

import Announcement from '@views/Announcement';
import Metas from '@views/Metas';
import GlobalRanking from '@views/GlobalRanking';
import { isWordCupStarted } from '@selectors/clock';
import { selectGlobalRankingTop } from '@selectors/ranking';

import Button from '@views/Button';

export const Ranking = ({ showRanking, onGoToRules }) => (
  <div className={`Ranking ${showRanking ? 'active' : ''}`}>
    <Metas
      title="Ranking General de Participantes del Prode 2026"
      description="Mirá el ranking general de participantes. Predecí los resultados. Invitá a tus amigos. Jugate un lugar en el ranking general."
      path="ranking"
    />
    <Announcement />
    <div className="hero-bg">
      <div className="hero-content">
        <h2>Ranking general</h2>
        <p>
          Tabla de posiciones del Prode del Mundial 2026 de Página|12. Se
          actualiza de manera automática después de cada partido.
        </p>
        <p>
          Cliqueá sobre el nombre de los participantes para revisar sus
          pronósticos y aciertos.
        </p>
      </div>
    </div>
    <div className="ranking-content">
      {showRanking ? (
        <div className="card card-ranking">
          <GlobalRanking />
          <div className="score-explainer-link">
            <Button
              type="link"
              onClick={(event) => {
                eventHandler(GAAction.ClickHowCalcsWorks)(event);
                onGoToRules();
              }}
            >
              ¿Cómo se calculan los puntajes?
            </Button>
          </div>
        </div>
      ) : (
        <div className="card">
          <h2>Próximamente</h2>
          <p>
            Tabla de posiciones del Prode del Mundial 2026 de Página|12. Se
            habilitará una vez que termine el primer partido del Mundial y se
            irá actualizando automáticamente con los resultados.
          </p>
        </div>
      )}
    </div>
  </div>
);

Ranking.propTypes = {
  showRanking: PropTypes.bool,
  onGoToRules: PropTypes.func.isRequired,
};
Ranking.defaultProps = {
  showRanking: false,
};

export const mapStateToProps = (state) => ({
  showRanking:
    isWordCupStarted(state) && !isEmpty(selectGlobalRankingTop(state)),
});

export const mapDispatchToProps = (dispatch) => ({
  onGoToRules: () => dispatch(redirect({ type: Pages.Rules })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Ranking);
